import { ThemeInterface } from "injectors/theme";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: ThemeInterface) => ({
  container: {},
  listOfItemsQuestionWrapper: {
    position: "relative",
  },
}));

export { useStyles };
